// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vw_a bhe_b bhe_wb"};